
import Api from '@/utils/api';
import MHeader from '../Header/Header.vue';
import SearchInput from '../SearchInput/SearchInput.vue';
import {
getShopCat,
search,
addCart,
getCartCount
} from '../../api';
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'
import Divider from 'vux/src/components/divider/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
data() {
return {
productList: [],
categoriesList: [],
brandsList: [],
scrollH: "300px",
shopCat: [],
list: "",
tabIndex: 0,
listIndex: "-1",
isMoreList: false,
loadText: '正在加载',
isLoad: false,
pages: '0',
shop_cat_id: "",
filterType: "category",
isBallArr: [],
seletedCategoryId: null,
pagination: {
page: 1,
pageSize: 6
}
}
},
components: {
MHeader,
Scroller,
LoadMore,
SearchInput,
Tab,
TabItem
},
created() {
if(this.$router.currentRoute && this.$router.currentRoute.query.categoryId){
this.seletedCategoryId = this.$router.currentRoute.query.categoryId
}
setTimeout(() => {
var fontSize = parseInt(document.documentElement.style.fontSize);
var h = 0.94;

this.scrollH = document.documentElement.clientHeight - 44 - parseInt(h * fontSize) + 'px';
console.log(this.scrollH)
});

},
methods: {
changeTab(item) {
this.filterType = item
this.seletedCategoryId = null
this.productList = []
this.pagination.page = 1
this.getProductList()
},
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});

},
navTab(index, categoryId) {
this.tabIndex = index;
this.seletedCategoryId = categoryId
this.productList = []
this.getProductList()
},
search(cd) {
this.$store.commit('showIsLoading');
search(`shop_cat_id=${this.shop_cat_id}&pages=${this.pages}`).then(res => {
if (res.data.error) {
alert(res.data.msg);
console.error(res);
return;
};
cd && cd(res.data.items);
});
},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
onScrollBtm() {
if(this.isMoreList){
this.isMoreList = false
this.pagination.page ++
this.getProductList()
}
},
getProductList () {
const searchParams = {
page: this.pagination.page,
pageSize: this.pagination.pageSize
}
if(this.seletedCategoryId){
if (this.filterType == 'category') {
searchParams.category = this.seletedCategoryId
} else if (this.filterType == 'brand') {
searchParams.brand = this.seletedCategoryId
}
}

this.loadText = '正在加载'
Api.getProductList(searchParams)
.then(res => {
this.productList = this.productList.concat(res.data)
if(this.productList.length < parseInt(res.headers.total)){
this.isMoreList = true
}else {
this.isMoreList = false
this.loadText = '没有更多数据'
}
this.$nextTick(() => {
this.$refs.scrollerEvent.reset()
})
})
}
},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerEvent.reset({
top: 0
})
});

Api.getCategoriesList({
showInMenu: true
})
.then(res => {
this.categoriesList = res.data
this.categoriesList.unshift({
_id: null,
name: '全部'
})
})

Api.getBrandsList()
.then(res => {
this.brandsList = res.data
this.brandsList.unshift({
_id: null,
name: '全部'
})
})
this.getProductList()
}
}



// WEBPACK FOOTER //
// ./src/components/Classify/Classify.vue